import { forwardRef } from 'react';
import CardBack from '../CardBack';
import './DeckSection.css';

// Cards drawn in the stack: enough to give the deck an edge, and a packet
// to lift off the top of it
const STACK = 18;
const PACKET = 9;
const REST = STACK - PACKET;

/**
 * The deck as a stack of card backs. DeckSection shuffles it; the fan
 * carries a second one from the deck's place down to the circle.
 */
const DeckStack = forwardRef(function DeckStack(_, ref) {
  return (
    <div className="deck-stack" ref={ref}>
      {Array.from({ length: STACK }, (_card, i) => {
        const inPacket = i >= REST;
        // How far up its half of the deck the card sits, 0 to 1: the
        // further up, the further it fans out during the shuffle
        const spread = inPacket ? (i - REST) / (PACKET - 1) : i / (REST - 1);
        return (
          <div
            key={i}
            className={`deck-card ${inPacket ? 'deck-card--packet' : ''}`}
            style={{ '--i': i, '--t': spread }}
          >
            <CardBack />
          </div>
        );
      })}
    </div>
  );
});

export default DeckStack;
